import _slicedToArray from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useState, useRef } from 'react';
import { useUncontrolled } from '@mantine/hooks';
import { Box } from '@mantine/core';
import { YearPicker } from './YearPicker/YearPicker.js';
import { MonthPicker } from './MonthPicker/MonthPicker.js';
import { MonthsList } from './MonthsList/MonthsList.js';
import useStyles from './CalendarBase.styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var CalendarBase = forwardRef(function (_a, ref) {
  var _b = _a,
      className = _b.className,
      classNames = _b.classNames,
      styles = _b.styles,
      month = _b.month,
      initialMonth = _b.initialMonth,
      onMonthChange = _b.onMonthChange,
      locale = _b.locale,
      _b$amountOfMonths = _b.amountOfMonths,
      amountOfMonths = _b$amountOfMonths === void 0 ? 1 : _b$amountOfMonths,
      _b$size = _b.size,
      size = _b$size === void 0 ? "sm" : _b$size,
      _b$allowLevelChange = _b.allowLevelChange,
      allowLevelChange = _b$allowLevelChange === void 0 ? true : _b$allowLevelChange,
      _b$initialLevel = _b.initialLevel,
      initialLevel = _b$initialLevel === void 0 ? "date" : _b$initialLevel,
      minDate = _b.minDate,
      maxDate = _b.maxDate,
      _b$__staticSelector = _b.__staticSelector,
      __staticSelector = _b$__staticSelector === void 0 ? "CalendarBase" : _b$__staticSelector,
      dayClassName = _b.dayClassName,
      dayStyle = _b.dayStyle,
      disableOutsideEvents = _b.disableOutsideEvents,
      excludeDate = _b.excludeDate,
      hideWeekdays = _b.hideWeekdays,
      fullWidth = _b.fullWidth,
      preventFocus = _b.preventFocus,
      _b$firstDayOfWeek = _b.firstDayOfWeek,
      firstDayOfWeek = _b$firstDayOfWeek === void 0 ? "monday" : _b$firstDayOfWeek,
      value = _b.value,
      onChange = _b.onChange,
      onDayMouseEnter = _b.onDayMouseEnter,
      range = _b.range,
      nextDecadeLabel = _b.nextDecadeLabel,
      nextMonthLabel = _b.nextMonthLabel,
      nextYearLabel = _b.nextYearLabel,
      previousDecadeLabel = _b.previousDecadeLabel,
      previousMonthLabel = _b.previousMonthLabel,
      previousYearLabel = _b.previousYearLabel,
      _b$labelFormat = _b.labelFormat,
      labelFormat = _b$labelFormat === void 0 ? "MMMM YYYY" : _b$labelFormat,
      weekdayLabelFormat = _b.weekdayLabelFormat,
      hideOutsideDates = _b.hideOutsideDates,
      isDateInRange = _b.isDateInRange,
      isDateFirstInRange = _b.isDateFirstInRange,
      isDateLastInRange = _b.isDateLastInRange,
      renderDay = _b.renderDay,
      weekendDays = _b.weekendDays,
      others = __objRest(_b, ["className", "classNames", "styles", "month", "initialMonth", "onMonthChange", "locale", "amountOfMonths", "size", "allowLevelChange", "initialLevel", "minDate", "maxDate", "__staticSelector", "dayClassName", "dayStyle", "disableOutsideEvents", "excludeDate", "hideWeekdays", "fullWidth", "preventFocus", "firstDayOfWeek", "value", "onChange", "onDayMouseEnter", "range", "nextDecadeLabel", "nextMonthLabel", "nextYearLabel", "previousDecadeLabel", "previousMonthLabel", "previousYearLabel", "labelFormat", "weekdayLabelFormat", "hideOutsideDates", "isDateInRange", "isDateFirstInRange", "isDateLastInRange", "renderDay", "weekendDays"]);

  var _useState = useState(initialLevel),
      _useState2 = _slicedToArray(_useState, 2),
      selectionState = _useState2[0],
      setSelectionState = _useState2[1];

  var _useStyles = useStyles({
    size: size,
    fullWidth: fullWidth,
    amountOfMonths: selectionState === "date" ? amountOfMonths : 1
  }, {
    name: __staticSelector,
    styles: styles,
    classNames: classNames
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var finalLocale = locale || theme.datesLocale;
  var daysRefs = useRef(Array(amountOfMonths).fill(0).map(function () {
    return [];
  }));

  var _useUncontrolled = useUncontrolled({
    value: month,
    defaultValue: initialMonth,
    finalValue: new Date(),
    onChange: onMonthChange,
    rule: function rule(val) {
      return val instanceof Date;
    }
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      _month = _useUncontrolled2[0],
      setMonth = _useUncontrolled2[1];

  var _useState3 = useState(_month.getFullYear()),
      _useState4 = _slicedToArray(_useState3, 2),
      yearSelection = _useState4[0],
      setYearSelection = _useState4[1];

  var minYear = minDate instanceof Date ? minDate.getFullYear() : 0;
  var maxYear = maxDate instanceof Date ? maxDate.getFullYear() : 1e4;
  var daysPerRow = 6;

  var focusOnNextFocusableDay = function focusOnNextFocusableDay(direction, monthIndex, payload) {
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var changeRow = ["down", "up"].includes(direction);
    var rowIndex = changeRow ? payload.rowIndex + (direction === "down" ? n : -n) : payload.rowIndex;
    var cellIndex = changeRow ? payload.cellIndex : payload.cellIndex + (direction === "right" ? n : -n);
    var dayToFocus = daysRefs.current[monthIndex][rowIndex][cellIndex];

    if (!dayToFocus) {
      return;
    }

    if (dayToFocus.disabled) {
      focusOnNextFocusableDay(direction, monthIndex, payload, n + 1);
    } else {
      dayToFocus.focus();
    }
  };

  var handleDayKeyDown = function handleDayKeyDown(monthIndex, payload, event) {
    var _a2;

    switch (event.code) {
      case "ArrowDown":
        {
          event.preventDefault();
          var hasRowBelow = payload.rowIndex + 1 < daysRefs.current[monthIndex].length;

          if (hasRowBelow) {
            focusOnNextFocusableDay("down", monthIndex, payload);
          }

          break;
        }

      case "ArrowUp":
        {
          event.preventDefault();
          var hasRowAbove = payload.rowIndex > 0;

          if (hasRowAbove) {
            focusOnNextFocusableDay("up", monthIndex, payload);
          }

          break;
        }

      case "ArrowRight":
        {
          event.preventDefault();
          var isNotLastCell = payload.cellIndex !== daysPerRow;

          if (isNotLastCell) {
            focusOnNextFocusableDay("right", monthIndex, payload);
          } else if (monthIndex + 1 < amountOfMonths) {
            if (daysRefs.current[monthIndex + 1][payload.rowIndex]) {
              (_a2 = daysRefs.current[monthIndex + 1][payload.rowIndex][0]) == null ? void 0 : _a2.focus();
            }
          }

          break;
        }

      case "ArrowLeft":
        {
          event.preventDefault();

          if (payload.cellIndex !== 0) {
            focusOnNextFocusableDay("left", monthIndex, payload);
          } else if (monthIndex > 0) {
            if (daysRefs.current[monthIndex - 1][payload.rowIndex]) {
              daysRefs.current[monthIndex - 1][payload.rowIndex][daysPerRow].focus();
            }
          }
        }
    }
  };

  return /* @__PURE__ */React.createElement(Box, __spreadValues({
    className: cx(classes.calendarBase, className),
    ref: ref
  }, others), selectionState === "year" && /* @__PURE__ */React.createElement(YearPicker, {
    size: size,
    value: yearSelection,
    minYear: minYear,
    maxYear: maxYear,
    onChange: function onChange(year) {
      setYearSelection(year);
      setSelectionState("month");
    },
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    nextDecadeLabel: nextDecadeLabel,
    previousDecadeLabel: previousDecadeLabel,
    preventFocus: preventFocus
  }), selectionState === "month" && /* @__PURE__ */React.createElement(MonthPicker, {
    size: size,
    value: {
      month: _month.getMonth(),
      year: _month.getFullYear()
    },
    year: yearSelection,
    onYearChange: setYearSelection,
    onNextLevel: function onNextLevel() {
      return setSelectionState("year");
    },
    locale: finalLocale,
    minDate: minDate,
    maxDate: maxDate,
    onChange: function onChange(monthValue) {
      setMonth(new Date(yearSelection, monthValue, 1));
      setSelectionState("date");
    },
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    nextYearLabel: nextYearLabel,
    previousYearLabel: previousYearLabel,
    preventFocus: preventFocus
  }), selectionState === "date" && /* @__PURE__ */React.createElement(MonthsList, {
    amountOfMonths: amountOfMonths,
    month: _month,
    locale: finalLocale,
    minDate: minDate,
    maxDate: maxDate,
    allowLevelChange: allowLevelChange,
    size: size,
    daysRefs: daysRefs,
    onMonthChange: setMonth,
    onNextLevel: function onNextLevel() {
      return setSelectionState("month");
    },
    onDayKeyDown: handleDayKeyDown,
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector,
    dayClassName: dayClassName,
    dayStyle: dayStyle,
    disableOutsideEvents: disableOutsideEvents,
    excludeDate: excludeDate,
    hideWeekdays: hideWeekdays,
    fullWidth: fullWidth,
    preventFocus: preventFocus,
    firstDayOfWeek: firstDayOfWeek,
    value: value,
    range: range,
    onChange: onChange,
    nextMonthLabel: nextMonthLabel,
    previousMonthLabel: previousMonthLabel,
    labelFormat: labelFormat,
    weekdayLabelFormat: weekdayLabelFormat,
    onDayMouseEnter: onDayMouseEnter,
    renderDay: renderDay,
    hideOutsideDates: hideOutsideDates,
    isDateInRange: isDateInRange,
    isDateFirstInRange: isDateFirstInRange,
    isDateLastInRange: isDateLastInRange,
    weekendDays: weekendDays
  }));
});
CalendarBase.displayName = "@mantine/dates/CalendarBase";
export { CalendarBase };